export default "__VITE_ASSET__BJvlUCtD__"